module.exports = __webpack_public_path__ + "static/glaciers-ec999c8e971027a586fef0d7d05850b0.jpg";